<template>
  <ScipherLayout>
    <ThoughtSpotHeader :cohort="cohort" v-if="cohort" />
    <div id="ts-embed" />
    <Loader v-if="isLoading" />
  </ScipherLayout>
</template>
<script>
import {
  init,
  SearchEmbed,
  RuntimeFilterOp,
  AuthType,
  EmbedEvent
} from '@thoughtspot/visual-embed-sdk';
import axios from '../../axios';
import Loader from '../../components/common/loader/Loader.vue';
import { errorDebug, toFormData } from '../../libraries/common';
import ThoughtSpotHeader from '../../components/cohorts/ThoughtSpotHeader.vue';
export default {
  components: { Loader, ThoughtSpotHeader },
  props: ['cohortId'],
  data() {
    return {
      cohort: null,
      isLoading: false,
    };
  },
  methods: {
    initThoughtSpot() {
    var isProduction = window['CurrentEnv'] === 'Production';
    var objectId = isProduction
       ? '14f59e32-f0cc-4d74-ac0f-9316d3bd5bf8'
       : '1b78af6c-84d1-49dd-9a25-7a72f1266b71';
    var dataSource = isProduction
      ? '07bccabc-4944-403a-9d6a-760bca74016a'
      : 'cf651d3a-5866-4ed6-9091-a489868ee2d8';
    var orgId  = isProduction
      ? 169883887
      : 0;
      init({
        thoughtSpotHost: 'https://eversana.thoughtspot.cloud',
        authType: AuthType.TrustedAuthTokenCookieless,
        disableTokenVerification: true,
        getAuthToken: () => axios.post('/Analytics/Thoughtspot/GetToken', toFormData({ objectId,orgId }))
          .then(({ data }) => data.token),
      });
      // Instantiate SearchEmbed class
      const embed = new SearchEmbed('#ts-embed', {
        frameParams: {
          width: '100%',
          height: '100%',
        },
        dataSource: dataSource,
        runtimeFilters: [{
          columnName: 'COHORTID', // Change this to your actual column name
          operator: RuntimeFilterOp.EQ,
          values: [this.cohortId] // Change this to your actual value
        }],
      });
      // Register event handlers
      embed
        .on(EmbedEvent.Init, this.showLoader)
        .on(EmbedEvent.Load, this.hideLoader)
        .on('answerPageLoading', payload =>
          console.log('Message received from embedded view: ' + JSON.stringify(payload))
        )
        .render();
    },
    showLoader() {
      this.isLoading = true;
    },
    hideLoader() {
      this.isLoading = false;
    },
  },
  mounted() {
    this.isLoading = true;
    axios.get(`/Analytics/Cohorts/${this.cohortId}`)
      .then(({ data }) => {
        this.cohort = data;
        this.initThoughtSpot();
      })
      .catch(errorDebug);
  },
}
</script>
<style lang="scss" scoped>
#ts-embed {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 121px);
}
</style>